/**
 * Shared overlays + typography for co-learning / museum modals.
 * Backdrops: warm Artmosphere cream/peach scrims + blur (avoid grey-brown slabs).
 */

const promptBackdropStyle = {
  WebkitBackdropFilter: 'blur(22px) saturate(1.12)',
  backdropFilter: 'blur(22px) saturate(1.12)',
};

const wallBackdropStyle = {
  WebkitBackdropFilter: 'blur(26px) saturate(1.18)',
  backdropFilter: 'blur(26px) saturate(1.18)',
};

const expandedBackdropStyle = {
  WebkitBackdropFilter: 'blur(40px) saturate(1.22)',
  backdropFilter: 'blur(40px) saturate(1.22)',
};

const nestedBackdropStyle = {
  WebkitBackdropFilter: 'blur(24px) saturate(1.15)',
  backdropFilter: 'blur(24px) saturate(1.15)',
};

/** Black-ink copy (React / museum shell) */
export const coLearningInkHeading = 'font-semibold text-[#141210]';
export const coLearningInkTitle = 'font-bold text-[#141210]';
export const coLearningInkBody = 'text-[#2a2622]';
export const coLearningInkMuted = 'text-[#4f4a45]';
export const coLearningInkLink = 'font-medium text-[#141210] underline-offset-2 hover:underline';

export const coLearningPromptBackdropProps = {
  className:
    'fixed inset-0 z-50 flex items-center justify-center bg-[rgba(255,251,245,0.45)] p-4 backdrop-blur-2xl backdrop-saturate-125',
  style: promptBackdropStyle,
};

export const coLearningGalleryPickerBackdropProps = {
  className:
    'fixed inset-0 z-50 flex items-center justify-center bg-[rgba(255,251,245,0.42)] p-4 backdrop-blur-2xl backdrop-saturate-125',
  style: promptBackdropStyle,
};

export const coLearningGalleryUploadBackdropProps = {
  className:
    'fixed inset-0 z-[80] flex items-center justify-center bg-[rgba(255,244,228,0.68)] p-3 backdrop-blur-3xl backdrop-saturate-150 sm:p-4',
  style: wallBackdropStyle,
};

export const coLearningGalleryUnshareBackdropProps = {
  className:
    'fixed inset-0 z-[82] flex items-center justify-center bg-[rgba(250,232,208,0.82)] p-4 backdrop-blur-2xl backdrop-saturate-125',
  style: nestedBackdropStyle,
};

export const coLearningWallBackdropProps = {
  className:
    'fixed inset-0 z-[420] flex items-center justify-center bg-[rgba(255,244,228,0.68)] px-2 py-2 backdrop-blur-3xl backdrop-saturate-150 sm:px-3 sm:py-3',
  style: wallBackdropStyle,
};

/** GalleryStudio — Ways style gallery sheet */
export const coLearningGallerySheetBackdropProps = {
  className:
    'fixed inset-0 z-[70] flex items-center justify-center bg-[rgba(255,244,228,0.68)] px-1 py-1 backdrop-blur-3xl backdrop-saturate-150 sm:px-2 sm:py-2',
  style: wallBackdropStyle,
};

/** Full-bleed artwork expand */
export const coLearningExpandedBackdropProps = {
  className:
    'fixed inset-0 z-[500] flex items-center justify-center bg-[rgba(253,238,216,0.78)] px-2 py-3 backdrop-blur-[40px] backdrop-saturate-150 sm:px-3 sm:py-5',
  style: expandedBackdropStyle,
};

/** Ways fullscreen image viewer */
export const coLearningExpandedGalleryViewerBackdropProps = {
  className:
    'fixed inset-0 z-[9999] flex items-center justify-center bg-[rgba(253,238,216,0.78)] px-2 py-3 backdrop-blur-[40px] backdrop-saturate-150 sm:px-3 sm:py-5',
  style: expandedBackdropStyle,
};

export const coLearningNestedBackdropProps = {
  className:
    'fixed inset-0 z-[520] flex items-center justify-center bg-[rgba(250,232,208,0.82)] px-4 backdrop-blur-2xl backdrop-saturate-125',
  style: nestedBackdropStyle,
};
